import { render, staticRenderFns } from "./Diseno.vue?vue&type=template&id=2daac5c2&"
import script from "./Diseno.vue?vue&type=script&lang=js&"
export * from "./Diseno.vue?vue&type=script&lang=js&"
import style0 from "./Diseno.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports